// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1hp6J","errors":"Errors_errors__llnpl"};